export const AccountKey = "AccountKey";
export const GlobalKey = "GlobalKey";
export const LocationKey = "LocationKey";
export const LocationProviderKey = "LocationProviderKey";
export const UserKey = "UserKey";
export const BillingAccountKey = "BillingAccountKey";
export const CredentialKey = "CredentialKey";
export const RemotePageKey = "RemotePageKey"

export const info = {
  [AccountKey]: {
    label: "Account"
  },
  [UserKey]: {
    label: "User"
  },
  [LocationKey]: {
    label: "Location"
  },
  [LocationProviderKey]: {
    label: "Location/Provider"
  },
  [GlobalKey]: {
    label: "Global- WARNING: Only use if certain job is necessary."
  },
  [BillingAccountKey]: {
    label: "Billing Account"
  },
  [CredentialKey]: {
    label: "External Credentials"
  },
  [RemotePageKey]: {
    label: "External Page"
  }
}
